// extracted by mini-css-extract-plugin
module.exports = {"bgSection1__imagen":"index-module--bgSection1__imagen--1Kamc","imagenBox10":"index-module--imagenBox10--2GkF1","bgSection1__line":"index-module--bgSection1__line--3SC6s"};